import { Dropdown } from "primereact/dropdown";
import { useProfile } from "../../Hooks/Features/Profile/useProfile";
import { SkeletonContainer, SkeletonLine } from '../Loader/Loader';
import IntegrateJiraToken from "../Layout/IntegrateJiraToken";
import { dateConvert } from '../../utils/Helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from 'primereact/dialog';
import ResetForm from '../resetPassword/ResetForm';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import _ from "underscore";
import { useCommon } from "../../Hooks/Common/useCommon";
import UserGroup from "../Timesheet/UserGroup";
import ProjectUpdate from "./ProjectUpdate";

const Profile = ({ userFromWidget, feedBackData }) => {
    const { selectedEmployee, setSelectedEmployee, option, tableData, tableCols, loader, getProfileInfo, loggedInUser, profileData, selectedData, setSelectedData, isChanged, setIsChanged, upsertUserNotification, handleLogout, sessionBodyTemplate, tagref, visible, setVisible, formValues, setFormValues, upsertProfile } = useProfile({ userFromWidget });
    const { checkPermission, getValuePermission } = useCommon();

    const rowClassName = (data) => {
        return data?.is_current_session ? "profile-current-session" : "";
    };

    const showUserGroup = getValuePermission("user_group");
    return (
        <div className='px-3 py-1'>
            {
                loader ? <div className="card-container bg-white"> <SkeletonLine numSkeletons={2} /> </div> : <div className="card-container bg-white d-flex justify-content-between p-2 px-4">
                    <div className="d-flex gap-3 align-items-center w100 position-relative">
                        <div className="w10">
                            <div>
                                <div style={{
                                    borderRadius: '50%',
                                    padding: '2px',
                                    background: 'conic-gradient(#55B038 0deg 90deg, #F39917 90deg 180deg, #E61B1F 180deg 270deg, #2A8CD4 270deg 360deg)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <img src={`${profileData?.user_details?.[0]?.image_url}?nocache=${Date.now()}`} alt="Profile" style={{ height: "80px", width: "82px", border: '2px solid white' }} className="rounded-circle" onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }} />
                                </div>
                            </div>
                        </div>
                        <div className="profile-details">
                            {
                                option?.userOption?.length > 1 ? <div className='w70'>
                                    <Dropdown
                                        placeholder="Select"
                                        options={option?.userOption}
                                        optionLabel='user_display_name'
                                        value={selectedEmployee}
                                        onChange={(e) => {
                                            e.target.value !== undefined && setIsChanged(true);
                                            setSelectedEmployee(e.target.value === undefined ? loggedInUser?.user : e.target.value)
                                            e.target.value === undefined && getProfileInfo(loggedInUser?.user?.user_code)
                                        }}
                                        filter
                                        filterInputAutoFocus
                                        showClear={selectedEmployee?.user_code === loggedInUser?.user?.user_code ? false : true}
                                        onHide={() => { if (isChanged) { getProfileInfo(selectedEmployee?.user_code); setIsChanged(false); } }}
                                    />
                                </div> : <div className='text-truncate' title={selectedEmployee?.user_display_name} style={{ fontSize: "16px", fontWeight: "bold" }}>{selectedEmployee?.user_display_name}</div>
                            }
                            <p className='py-1'>{profileData?.user_details?.[0]?.role_on_project || "-"}</p>
                            <p ref={() => checkPermission('Sidebar', tagref)}><span ref={tagref} id='{"tabname": "sidebar", "data": "insights_category_display"}'><strong>Insights Category:</strong> {profileData?.user_details?.[0]?.user_category_name || " -"} |</span> <strong>Status:</strong> {profileData?.user_details?.[0]?.user_status_name || "-"}</p>
                        </div>
                    </div>
                </div>
            }
            <div className='d-flex justify-content-between'>
                <div className='d-flex flex-column gap-3 p-0 m-0 my-3 w40'>
                    <div className="employee-details card-container bg-white p-0 ">
                        <div className='card-header'>Employee Information</div>
                        {loader ? <div style={{ height: "150px" }} className="m-2"><SkeletonContainer /> </div> : tableData?.employee_details?.map(({ label, value, title }) => (
                            <div key={label} className="w100 d-flex px-2">
                                <div className="w40" style={{ fontWeight: 600, fontSize: "12px" }} title={title || ""}>{label}:</div>
                                <div className="w60" style={{ fontWeight: 400, fontSize: "12px" }}>{value}</div>
                            </div>
                        ))}
                    </div>
                    <div className="employee-details card-container bg-white p-0 ">
                        <div className='card-header w-100 d-flex justify-content-between'>Project & Technology
                            <FontAwesomeIcon icon="fa-solid fa-pen-to-square" className="c-pointer" onClick={() => setVisible((prev) => ({ ...prev, project_change: true }))} />

                        </div>
                        {loader ? <div style={{ height: "85px" }} className="m-2"><SkeletonContainer /> </div> : tableData?.project_tech_details?.map(({ label, value, title }) => (
                            <div key={label} className="w100 d-flex px-2">
                                <div className="w40" style={{ fontWeight: 600, fontSize: "12px" }} title={title || ""}>{label}:</div>
                                <div className="w60" style={{ fontWeight: 400, fontSize: "12px" }}>{value}</div>
                            </div>
                        ))}
                    </div>
                    {!showUserGroup && <div className="employee-details card-container bg-white p-0 ">
                        <div className='card-header'>
                            <div>User Group</div>
                            {selectedEmployee?.user_code === loggedInUser?.user?.user_code &&
                                <div className="d-flex gap-2">
                                    <div title='View All User Groups' className='c-pointer' onClick={() => setVisible((prev) => ({ ...prev, user_group: true }))}><FontAwesomeIcon icon="fa-solid fa-eye" /></div>
                                    <div className='c-pointer' title='Save User Group Selection' onClick={() => upsertUserNotification(true)}><FontAwesomeIcon icon="fa-solid fa-floppy-disk" /></div>
                                </div>
                            }
                        </div>
                        {loader ? <div style={{ height: "85px" }} className="m-2"><SkeletonContainer /> </div> :
                            <div className="w100 d-flex align-items-center gap-2 px-2">
                                <input type='checkbox' value={selectedData?.view_user_group} checked={selectedData?.view_user_group} onChange={(e) => setSelectedData((prev) => ({ ...prev, view_user_group: e.target.checked }))} />
                                <div style={{ fontWeight: 400, fontSize: "12px" }} >View Group Wise User Data</div>
                            </div>
                        }
                    </div>}
                    <div className="employee-details card-container bg-white p-0">
                        <div className='card-header'>
                            <div>Password & Security</div>
                            {selectedEmployee?.user_code === loggedInUser?.user?.user_code && <div title='Change Password' className='c-pointer' onClick={() => setVisible((prev) => ({ ...prev, reset_pwd: true }))}><FontAwesomeIcon icon="fa-solid fa-key" /></div>}
                        </div>
                        {loader ? <div style={{ height: "85px" }} className="m-2"><SkeletonContainer /> </div> :
                            <div className="px-2">
                                <div className='d-flex justify-content-between w100'>
                                    <div className="w30" style={{ fontWeight: 600, fontSize: "12px" }}>Last Changed:</div>
                                    <div className="w70" style={{ fontWeight: 400, fontSize: "12px" }}>{profileData?.user_details?.[0]?.reset_password_datetime ? dateConvert(profileData?.user_details?.[0]?.reset_password_datetime, "date-time-months") : "-"}</div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="employee-details card-container bg-white p-0">
                        <div className='card-header'>
                            <div>Notification Preferences</div>
                            {(selectedEmployee?.user_code === loggedInUser?.user?.user_code && !profileData?.user_details?.[0]?.department?.toLowerCase()?.includes("srk exports")) && <div className='c-pointer' title='Save Preferences' onClick={() => upsertUserNotification()}><FontAwesomeIcon icon="fa-solid fa-floppy-disk" /></div>}
                        </div>
                        {loader ? <div style={{ height: "85px" }} className="m-2"><SkeletonContainer /> </div> : tableData?.notification_details?.map((item) => (
                            <div key={item?.key} className="w100 d-flex align-items-center gap-2 px-2">
                                <input type='checkbox' value={selectedData?.notification?.[item?.key]} checked={selectedData?.notification?.[item?.key]} onChange={() => setSelectedData((prev) => ({ ...prev, notification: { ...prev.notification, [item?.key]: !selectedData?.notification?.[item?.key] } }))} disabled={(selectedEmployee?.user_code !== loggedInUser?.user?.user_code) || profileData?.user_details?.[0]?.department?.toLowerCase()?.includes("srk exports")} />
                                <div style={{ fontWeight: 400, fontSize: "12px" }} >{item?.label}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className='d-flex flex-column gap-3 p-0 m-0 my-3' style={{ width: "58%" }}>
                    {
                        selectedEmployee?.user_code === loggedInUser?.user?.user_code && <div className="employee-details card-container bg-white p-0">
                            <div className='card-header d-flex justify-content-between align-items-center'>
                                <div>Survey Scores (Average)</div>
                            </div>
                            {loader ? (
                                <div style={{ height: "100px" }} className="m-2">
                                    <SkeletonContainer />
                                </div>
                            ) : (
                                <div className="p-2">
                                    {
                                        feedBackData?.dynamicColumns?.length <= 0 ? <div className="text-center">No data available</div> : <DataTable
                                            value={feedBackData?.tableValue}
                                            className="p-datatable-sm"
                                            responsiveLayout="scroll"
                                            emptyMessage="No data available"
                                        >
                                            {feedBackData?.dynamicColumns?.map((col) => (
                                                <Column
                                                    key={col.field}
                                                    field={col.field}
                                                    header={col.header}
                                                    headerStyle={{ textAlign: 'center', fontSize: '12px', textTransform: 'capitalize', backgroundColor: '#fdfdfd' }}
                                                    style={{ textAlign: 'center', minWidth: '80px' }}
                                                    body={(rowData) => {
                                                        const hasDescription = !!col.description;
                                                        return (
                                                            <div
                                                                title={hasDescription ? col.description : undefined}
                                                                style={{
                                                                    cursor: hasDescription ? 'help' : 'default',
                                                                    width: '100%',
                                                                    padding: '5px 0'
                                                                }}
                                                            >
                                                                {rowData[col.field]}
                                                            </div>
                                                        );
                                                    }}
                                                />
                                            ))}
                                            <Column
                                                field="survey_avg"
                                                header="Avg"
                                                headerStyle={{ textAlign: 'center' }}
                                                style={{ textAlign: 'center', fontWeight: 'bold', minWidth: '60px' }}
                                            />
                                        </DataTable>
                                    }
                                </div>
                            )}
                        </div>
                    }
                    <div className="employee-details card-container bg-white p-0 ">
                        <div className='card-header'>Token Information</div>
                        {selectedEmployee?.user_code === loggedInUser?.user?.user_code ?
                            <div className='p-2'>
                                <IntegrateJiraToken fromProfile={true} />
                            </div>
                            : <div style={{ height: "100px" }}></div>}
                    </div>
                    <div className="employee-details card-container bg-white p-0">
                        <div className='card-header'>
                            <div>Active Sessions</div>
                            {selectedEmployee?.user_code === loggedInUser?.user?.user_code &&
                                <div className='d-flex gap-2 align-items-center'>
                                    <FontAwesomeIcon icon="fa-solid fa-right-from-bracket" title='Logout selected' className='c-pointer' onClick={() => handleLogout(false)} />
                                    <FontAwesomeIcon icon="fa-solid fa-circle-xmark" title='Logout All' className='c-pointer' onClick={() => handleLogout(true)} />
                                </div>}
                        </div>
                        {loader ? <div style={{ height: "100px" }} className="m-2"><SkeletonContainer /> </div> :
                            <div className='d-flex justify-content-center align-items-center mb-1'>
                                <DataTable value={_.sortBy(profileData?.active_sessions_details, "is_current_session")?.reverse()} className='w95 profile-session-dt' scrollable scrollHeight="19vh" selectionMode={selectedEmployee?.user_code === loggedInUser?.user?.user_code ? "multiple" : null} selection={selectedData?.session} onSelectionChange={(e) => setSelectedData((prev) => ({ ...prev, session: _.filter(e?.value, item => !item?.is_current_session) }))} rowClassName={rowClassName}>
                                    {tableCols?.active_session?.map(col => (
                                        <Column key={col?.field} field={col?.field} header={col?.header} style={{ width: col?.field === "token_generate_datetime" ? "12vw" : "auto" }} body={(rowdata) => sessionBodyTemplate(rowdata, col)}
                                        />
                                    ))}
                                </DataTable>
                            </div>}
                    </div>
                    <div className="employee-details card-container bg-white p-0">
                        <div className='card-header'>Shift Details</div>
                        {loader ? <div style={{ height: "100px" }} className="m-2"><SkeletonContainer /> </div> :
                            <div className='d-flex justify-content-center align-items-center mb-1'>
                                <DataTable value={_.filter(profileData?.shift_details, item => item?.group_id)} className='w95' scrollable scrollHeight="19vh">
                                    {tableCols?.shift?.map(col => (
                                        <Column key={col?.field} field={col?.field} header={col?.header}
                                            body={(rowdata) => { return <div>{(col?.field === "effective_start_date" || col?.field === "effective_end_date") ? ((rowdata?.[col?.field] && rowdata?.[col?.field] !== "Present") ? dateConvert(rowdata?.[col?.field], "day-mon-year") : "Present") : rowdata?.[col?.field]}</div> }}
                                        />
                                    ))}
                                </DataTable>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <Dialog visible={visible?.reset_pwd} onHide={() => setVisible((prev) => ({ ...prev, reset_pwd: false }))} className='modal-xsmall' draggable={false} header="Change Password" >
                <div className='d-flex justify-content-between' style={{ width: "100%" }}>
                    <ResetForm flag={true} />
                </div>
            </Dialog>

            <Dialog visible={visible?.user_group} onHide={() => setVisible((prev) => ({ ...prev, user_group: false }))} className='modal-large' draggable={false} header="User Group" style={{ width: "60vw" }}>
                <UserGroup />
            </Dialog>
            <ProjectUpdate visible={visible} setVisible={setVisible} option={option} formValues={formValues} setFormValues={setFormValues} upsertProfile={upsertProfile} />
        </div>
    )
}

export default Profile